import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import { Container } from 'semantic-ui-react';
import Link from './Link';
import { toSnakeCase } from '../helpers/common';

const CallToAction = (props) => {
  const { module } = props;
  const { anchorTagLinkText, backgroundColour, altHeading, callToAction } = module;
  const { databaseId } = callToAction || {};
  const data = useStaticQuery(graphql`
    query callToAction {
      allWpCallToAction {
        edges {
          node {
            databaseId
            callToActionFields {
              columns {
                iconTitleColumn {
                  icon {
                    altText
                    sourceUrl
                  }
                }
                linkColumn {
                  title
                  preText
                  link {
                    title
                    target
                    url
                  }
                  linkTwo {
                    title
                    target
                    url
                  }
                }
              }
            }
          }
        }
      }
    }
  `);
  
  let { node: callToActionData } = data.allWpCallToAction.edges.find((edge) => edge.node.databaseId === databaseId) || {};
  const {
    callToActionFields: {
      columns: {
        iconTitleColumn: { icon },
        linkColumn: { title = '', preText = '', link = {}, linkTwo = {} },
      },
    },
  } = callToActionData || {
    callToActionFields: {
      columns: {
        iconTitleColumn: {},
        linkColumn: {},
      },
    },
  };
  
  return (
    <section className="call-to-action" id={anchorTagLinkText && `${toSnakeCase(anchorTagLinkText)}`}>
      <Container>
        <div className="grid-wrapper">
          <div className={`call-to-action__container call-to-action__background call-to-action__${backgroundColour}`}>
            {icon && icon.sourceUrl && <img className="call-to-action__icon" src={icon.sourceUrl} alt={icon.altText} />}

            {callToAction?.title ? (
              <>
                {altHeading ? <h3 className="call-to-action__heading call-to-action__alt-heading">{callToAction.title}</h3> : <h2 className="call-to-action__heading">{callToAction.title}</h2>}
              </>
            ) : null}

            {preText && <p className="call-to-action__pre-text">{preText}</p>}
            {link || linkTwo ? (
              <div className={`call-to-action__link-wrapper ${link && linkTwo ? 'call-to-action__link-grid' : ''}`}>
                {link && link.url && (
                  <Link to={link.url} target={link.target} className="button button--outline call-to-action__link">
                    {link.title}
                  </Link>
                )}
                {linkTwo && linkTwo.url && (
                  <Link to={linkTwo.url} target={linkTwo.target} className="button button--outline call-to-action__link">
                    {linkTwo.title}
                  </Link>
                )}
              </div>
            ) : null}
          </div>
        </div>
      </Container>
    </section>
  );
};

export default CallToAction;
